document.addEventListener("DOMContentLoaded", function () {
  const listContainer = document.getElementById("conversationList");
  if (!listContainer) return; // Only execute on messaging page

  let currentStatus = "NEU";
  let currentChannel = "";
  let currentSearchTerm = "";
  let currentConversationId = null;
  let currentSelectedTemplateId = null;
  let currentSelectedTemplateIsWhatsapp = false;
  let isTimerExpired = false;

  const updateInputState = () => {
    const btnS = document.getElementById("btnSendMessage");
    const msgI = document.getElementById("messageInput");
    const btnA = document.getElementById("btnAttachFile");

    let canSend = true;
    let canType = true;
    let canAttach = true;

    if (isTimerExpired) {
      canSend = false;
      canType = false;
      canAttach = false;
    }

    if (currentSelectedTemplateIsWhatsapp) {
      canSend = true;
      canType = false;
      canAttach = false;
    }

    if (msgI) msgI.disabled = !canType;
    if (btnS) btnS.disabled = !canSend;
    if (btnA) btnA.disabled = !canAttach;
  };
  let whatsappTimerInterval = null;

  const chatPane = document.getElementById("chatPane");
  const emptyChatPane = document.getElementById("emptyChatPane");
  const messagesContainer = document.getElementById("chatMessages");

  const csrfToken = document.querySelector('meta[name="_csrf"]')?.content;
  const csrfHeader = document.querySelector('meta[name="_csrf_header"]')?.content;

  // Fetch CSRF headers helper
  const getHeaders = () => {
    const headers = {
      "Content-Type": "application/json",
    };
    if (csrfToken && csrfHeader) {
      headers[csrfHeader] = csrfToken;
    }
    return headers;
  };

  const updateUnreadCounts = () => {
    fetch("/api/cloud-messaging/unread-counts")
      .then((res) => {
        if (!res.ok) throw new Error("Unread counts fetch failed");
        return res.json();
      })
      .then((data) => {
        document.querySelectorAll("#statusTabs .btn").forEach((btn) => {
          const status = btn.getAttribute("data-status");
          const dot = btn.querySelector(".unread-dot");
          if (dot) {
            if (data[status]) {
              dot.classList.remove("d-none");
            } else {
              dot.classList.add("d-none");
            }
          }
        });
      })
      .catch((err) => console.error(err));
  };

  // Load Conversations
  const loadConversations = () => {
    listContainer.innerHTML = '<div class="text-center p-4 text-muted">Lade...</div>';

    let url = `/api/cloud-messaging/conversations?status=${currentStatus}`;
    if (currentChannel) url += `&channel=${currentChannel}`;
    if (currentSearchTerm) url += `&term=${encodeURIComponent(currentSearchTerm)}`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error("API Error: " + response.status);
        return response.json();
      })
      .then((data) => {
        listContainer.innerHTML = "";
        if (!data || !data.content || data.content.length === 0) {
          listContainer.innerHTML =
            '<div class="text-center p-4 text-muted">Keine Konversationen gefunden.</div>';
          return;
        }

        data.content.forEach((conv) => {
          const el = document.createElement("div");
          el.className = `conversation-item ${conv.id === currentConversationId ? "active" : ""}`;
          el.onclick = () => loadMessages(conv);

          let channelIcon = getChannelIcon(conv.channel);
          const dateValue = conv.lastMessageCreated || conv.created;
          let timeStr = dateValue
            ? new Date(dateValue).toLocaleString("de-DE", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
            : "";
          let avatarHtml = getAvatarHtml(conv.kontakt?.vorname, conv.kontakt?.nachname, null, "md");
          let lastMsgStr = conv.lastMessageSnippet || "Kontakt via " + conv.channel;

          el.innerHTML = `
                        <div class="d-flex align-items-center w-100">
                            ${avatarHtml}
                            <div class="flex-grow-1 ms-3" style="min-width: 0;">
                                <div class="d-flex justify-content-between align-items-center mb-1">
                                    <strong class="text-truncate">${conv.kontakt?.vorname || ""} ${conv.kontakt?.nachname || ""}</strong>
                                    <small class="text-muted ms-2 flex-shrink-0">${timeStr}</small>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <small class="text-muted" style="max-width: 85%; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;">
                                        ${lastMsgStr}
                                    </small>
                                    <div class="ms-2 flex-shrink-0">
                                        ${channelIcon}
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
          listContainer.appendChild(el);
        });
      })
      .catch((err) => {
        console.error(err);
        listContainer.innerHTML = '<div class="text-danger p-4">Fehler beim Laden.</div>';
      });
  };

  // Load Messages for a Conversation
  const loadMessages = (conv) => {
    currentConversationId = conv.id;
    emptyChatPane.style.display = "none";
    chatPane.style.display = "flex";
    document.querySelector(".messaging-container")?.classList.add("mobile-chat-active");

    clearInterval(whatsappTimerInterval);
    const timerContainer = document.getElementById("whatsappTimerContainer");
    const expiredContainer = document.getElementById("whatsappExpiredContainer");
    const msgInput = document.getElementById("messageInput");
    const btnSend = document.getElementById("btnSendMessage");
    const btnAttach = document.getElementById("btnAttachFile");

    if (timerContainer) timerContainer.style.display = "none";
    if (expiredContainer) expiredContainer.style.display = "none";
    if (msgInput) msgInput.disabled = false;
    if (btnSend) btnSend.disabled = false;
    if (btnAttach) btnAttach.disabled = false;

    const chatAvatarContainer = document.getElementById("chatAvatar");
    if (chatAvatarContainer) {
      chatAvatarContainer.innerHTML =
        `<a href="/contact/${conv.kontakt?.id}" class="text-decoration-none d-block">` +
        getAvatarHtml(conv.kontakt?.vorname, conv.kontakt?.nachname, null, "md").replace(
          "avatar-container me-3",
          "avatar-container",
        ) +
        `</a>`;
    }
    document.getElementById("chatName").innerHTML =
      `<a href="/contact/${conv.kontakt?.id}" class="text-dark text-decoration-none">${conv.kontakt?.vorname || ""} ${conv.kontakt?.nachname || ""}</a>`;
    document.getElementById("chatMeta").textContent = getChannelRef(conv);

    // Update active state in list
    document.querySelectorAll(".conversation-item").forEach((el) => el.classList.remove("active"));
    // Re-render list to show active (simplified)
    loadConversations();

    const templateDropdownContainer = document.getElementById("templateDropdownContainer");
    const templateDropdownList = document.getElementById("templateDropdownList");

    if (templateDropdownContainer && templateDropdownList) {
      let fetchChannels = [conv.channel];
      if (conv.channel === "WHATSAPP_TEMPLATE" || conv.channel === "WHATSAPP_DIRECT") {
        fetchChannels = ["WHATSAPP_DIRECT", "WHATSAPP_TEMPLATE"];
      }

      Promise.all(
        fetchChannels.map((ch) =>
          fetch(`/api/cloud-messaging/templates?channel=${ch}&type=DIREKTNACHRICHT`).then((res) =>
            res.json(),
          ),
        ),
      )
        .then((results) => {
          const uniqueTemplates = new Map();
          results.flat().forEach((t) => {
            if (!uniqueTemplates.has(t.id)) {
              uniqueTemplates.set(t.id, t);
            }
          });
          let templates = Array.from(uniqueTemplates.values());

          templates = templates.filter((t) => {
            if (
              t.channels &&
              t.channels.includes("WHATSAPP_TEMPLATE") &&
              t.type === "TERMINBUCHUNG"
            ) {
              return false;
            }
            return true;
          });

          if (templates && templates.length > 0) {
            templateDropdownContainer.style.display = "block";
            templateDropdownList.innerHTML = "";

            const clearLi = document.createElement("li");
            const clearA = document.createElement("a");
            clearA.className = "dropdown-item text-danger";
            clearA.href = "#";
            clearA.textContent = "Template abwählen";
            clearA.onclick = (e) => {
              e.preventDefault();
              currentSelectedTemplateId = null;
              currentSelectedTemplateIsWhatsapp = false;
              const msgI = document.getElementById("messageInput");
              if (msgI) msgI.value = "";
              updateInputState();
            };
            clearLi.appendChild(clearA);
            templateDropdownList.appendChild(clearLi);

            const dividerLi = document.createElement("li");
            dividerLi.innerHTML = '<hr class="dropdown-divider">';
            templateDropdownList.appendChild(dividerLi);

            templates.forEach((t) => {
              const li = document.createElement("li");
              const a = document.createElement("a");
              a.className = "dropdown-item";
              a.href = "#";

              let displayText = t.beschreibung || t.subject;
              if (t.channels && t.channels.includes("WHATSAPP_TEMPLATE")) {
                displayText = "€ " + displayText;
              }
              a.textContent = displayText;
              a.onclick = (e) => {
                e.preventDefault();

                let tmp = document.createElement("DIV");
                tmp.innerHTML = t.content || "";
                let content = tmp.textContent || tmp.innerText || "";

                const vorname = conv.kontakt?.vorname || "";
                const nachname = conv.kontakt?.nachname || "";
                const name = (vorname + " " + nachname).trim();

                content = content.replace(/#Vorname#/g, vorname);
                content = content.replace(/#Nachname#/g, nachname);
                content = content.replace(/#Name#/g, name);

                const msgInput = document.getElementById("messageInput");
                if (msgInput) msgInput.value = content;

                currentSelectedTemplateId = t.id;
                currentSelectedTemplateIsWhatsapp =
                  t.channels && t.channels.includes("WHATSAPP_TEMPLATE");
                updateInputState();
              };
              li.appendChild(a);
              templateDropdownList.appendChild(li);
            });
          } else {
            templateDropdownContainer.style.display = "none";
          }
        })
        .catch((err) => {
          console.error("Error loading templates", err);
          templateDropdownContainer.style.display = "none";
        });
    }

    messagesContainer.innerHTML =
      '<div class="text-center p-4 text-muted">Lade Nachrichten...</div>';

    fetch(`/api/cloud-messaging/conversations/${conv.id}/messages`)
      .then((response) => {
        if (!response.ok) throw new Error("API Error: " + response.status);
        return response.json();
      })
      .then((data) => {
        messagesContainer.innerHTML = "";
        if (data && data.content) {
          const msgs = data.content.reverse();

          let currentDay = "";
          let lastDirection = null;

          msgs.forEach((msg) => {
            const dateObj = new Date(msg.timestamp);
            const dayStr = dateObj.toLocaleDateString("de-DE", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            });

            if (dayStr !== currentDay) {
              currentDay = dayStr;
              lastDirection = null; // Reset block for new day
              const dateSeparator = document.createElement("div");
              dateSeparator.className = "text-center my-3 w-100";
              dateSeparator.innerHTML = `<span class="badge message-date-separator shadow-sm px-3 py-2 rounded-pill">${dayStr}</span>`;
              messagesContainer.appendChild(dateSeparator);
            }

            const isOutbound = msg.direction === "OUTBOUND";
            const showAvatar = lastDirection !== msg.direction;
            lastDirection = msg.direction;

            const timeStr = dateObj.toLocaleTimeString("de-DE", {
              hour: "2-digit",
              minute: "2-digit",
            });
            const div = document.createElement("div");
            div.className = `d-flex w-100 mb-2 ${isOutbound ? "justify-content-end" : "justify-content-start"}`;

            let avatarHtml = "";
            if (showAvatar) {
              if (isOutbound) {
                let outName = msg.createdByName || "Ich";
                let parts = outName.split(" ");
                let vName = parts[0] || "I";
                let nName = parts.length > 1 ? parts[1] : "";
                avatarHtml = getAvatarHtml(vName, nName, null, "sm").replace("me-3", "");
              } else {
                avatarHtml = getAvatarHtml(
                  conv.kontakt?.vorname,
                  conv.kontakt?.nachname,
                  null,
                  "sm",
                ).replace("me-3", "");
              }
            }

            let nameLabel = "";
            if (showAvatar) {
              const dispName = isOutbound
                ? msg.createdByName || "Ich"
                : conv.kontakt?.vorname || "Kontakt";
              nameLabel = `<div class="small text-muted mb-1 fw-bold ${isOutbound ? "text-end" : "text-start"}">${dispName}</div>`;
            }

            let tickHtml = "";
            if (isOutbound) {
              if (msg.status === "GESENDET") {
                tickHtml = `<i class="bi bi-check2 ms-1" style="font-size: 1rem; margin-bottom: -2px;"></i>`;
              } else if (msg.status === "EMPFANGEN") {
                tickHtml = `<i class="bi bi-check2-all ms-1" style="font-size: 1rem; margin-bottom: -2px;"></i>`;
              } else if (msg.status === "GELESEN") {
                tickHtml = `<i class="bi bi-check2-all ms-1" style="color: #0d6efd; font-size: 1rem; margin-bottom: -2px;"></i>`;
              } else if (msg.status === "FEHLER") {
                tickHtml = `<i class="bi bi-x-circle ms-1" style="color: #dc3545; font-size: 1rem; margin-bottom: -2px;"></i>`;
              } else {
                tickHtml = `<i class="bi bi-check2-all ms-1" style="font-size: 1rem; margin-bottom: -2px;"></i>`;
              }
            }

            const mediaHtml = getMediaHtml(msg);
            // Reiner Platzhalter wie "[Bild]" ist überflüssig, wenn das Medium angezeigt wird
            const showContent = !mediaHtml || !MEDIA_PLACEHOLDER_REGEX.test(msg.content || "");

            const bubbleContent = `
                            ${nameLabel}
                            <div class="message-bubble shadow-sm ${isOutbound ? "message-outbound" : "message-inbound"}" style="word-break: break-word; min-width: 100px;" data-message-id="${msg.externalMessageId}">
                                ${mediaHtml}
                                <div>${showContent && msg.content ? msg.content.replace(/\\n/g, "<br>") : ""}</div>
                                <div class="d-flex justify-content-end align-items-center mt-1">
                                    <span class="message-time small" style="font-size: 0.75rem;">${timeStr}</span>
                                    <span class="tick-container">${tickHtml}</span>
                                </div>
                            </div>
                        `;

            if (isOutbound) {
              div.innerHTML = `
                                <div class="d-flex flex-column align-items-end" style="max-width: 80%;">
                                    <div class="d-flex w-100 justify-content-end">
                                        <div class="d-flex flex-column align-items-end">
                                            ${bubbleContent}
                                        </div>
                                        <div class="ms-2 mt-4" style="width: 30px;">
                                            ${showAvatar ? avatarHtml : ""}
                                        </div>
                                    </div>
                                </div>
                            `;
            } else {
              div.innerHTML = `
                                <div class="d-flex flex-column align-items-start" style="max-width: 80%;">
                                    <div class="d-flex w-100 justify-content-start">
                                        <div class="me-2 mt-4" style="width: 30px;">
                                            ${showAvatar ? avatarHtml : ""}
                                        </div>
                                        <div class="d-flex flex-column align-items-start">
                                            ${bubbleContent}
                                        </div>
                                    </div>
                                </div>
                            `;
            }

            messagesContainer.appendChild(div);
          });
          scrollToBottom();

          // WhatsApp Direct 24h Timer Logic
          if (conv.channel === "WHATSAPP_DIRECT") {
            let lastInboundMsg = null;
            msgs.forEach((msg) => {
              if (msg.direction === "INBOUND") {
                lastInboundMsg = msg;
              }
            });

            if (lastInboundMsg) {
              const inboundTime = new Date(lastInboundMsg.timestamp).getTime();
              const expireTime = inboundTime + 24 * 60 * 60 * 1000;

              const updateTimer = () => {
                const now = new Date().getTime();
                const diff = expireTime - now;

                if (diff <= 0) {
                  clearInterval(whatsappTimerInterval);
                  isTimerExpired = true;
                  if (timerContainer) timerContainer.style.display = "none";
                  if (expiredContainer) expiredContainer.style.display = "block";
                  updateInputState();
                } else {
                  isTimerExpired = false;
                  if (timerContainer) {
                    timerContainer.style.display = "block";
                    timerContainer.classList.remove("text-success", "text-warning", "text-danger");
                    const hForColor = Math.floor(diff / (1000 * 60 * 60));
                    if (hForColor >= 6) {
                      timerContainer.classList.add("text-success");
                    } else if (hForColor >= 3) {
                      timerContainer.classList.add("text-warning");
                    } else {
                      timerContainer.classList.add("text-danger");
                    }
                  }
                  if (expiredContainer) expiredContainer.style.display = "none";
                  const h = Math.floor(diff / (1000 * 60 * 60));
                  const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                  const s = Math.floor((diff % (1000 * 60)) / 1000);
                  const timerText = document.getElementById("whatsappTimer");
                  if (timerText) {
                    timerText.innerText = `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
                  }
                  updateInputState();
                }
              };

              updateTimer(); // Initial call
              whatsappTimerInterval = setInterval(updateTimer, 1000);
            } else {
              isTimerExpired = true;
              if (timerContainer) timerContainer.style.display = "none";
              if (expiredContainer) expiredContainer.style.display = "block";
              updateInputState();
            }
          } else {
            isTimerExpired = false;
            updateInputState();
          }

          // Re-fetch unread counts because messages were just marked as read
          updateUnreadCounts();
        }
      })
      .catch((err) => console.error(err));
  };

  const appendMessage = (msg) => {
    // Find current conversation data (hacky but functional for reply since it reloads list)
    loadConversations();
    // Since loadConversations is async and we need to show the message immediately,
    // we can just re-fetch the entire message list for the current conversation to get the grouping correct.
    if (currentConversationId) {
      // We need conv object. We can fetch it or just use the global fetch messages which will handle grouping.
      // But we need the conv object. Let's fetch it from the API or just rely on websocket refresh.
      fetch(`/api/cloud-messaging/conversations?status=`); // Too complex.
      // Simpler: Just reload the whole conversation pane
      // But we don't have conv object here anymore.
      // Wait, we can fetch the conversation from the server first
    }
  };

  const scrollToBottom = () => {
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  };

  // Tabs
  document.querySelectorAll("#statusTabs .btn").forEach((tab) => {
    tab.addEventListener("click", (e) => {
      document.querySelectorAll("#statusTabs .btn").forEach((t) => t.classList.remove("active"));
      e.target.classList.add("active");
      currentStatus = e.target.getAttribute("data-status");
      loadConversations();
    });
  });

  // Channel Filter
  document.querySelectorAll("#channelFilter .dropdown-item").forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      document
        .querySelectorAll("#channelFilter .dropdown-item")
        .forEach((i) => i.classList.remove("active"));
      e.target.classList.add("active");
      currentChannel = e.target.getAttribute("data-channel");
      loadConversations();
    });
  });

  // Search
  const searchInput = document.getElementById("searchInput");
  let searchTimeout;
  if (searchInput) {
    searchInput.addEventListener("input", (e) => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        currentSearchTerm = e.target.value;
        loadConversations();
      }, 500);
    });
  }

  // Send Message
  const btnSend = document.getElementById("btnSendMessage");
  const msgInput = document.getElementById("messageInput");

  const sendMessage = () => {
    const text = msgInput.value.trim();
    if (!currentConversationId) return;
    if (!text && !currentSelectedTemplateIsWhatsapp) return;

    btnSend.disabled = true;

    let bodyData = { content: text };
    if (currentSelectedTemplateId) {
      bodyData.templateId = currentSelectedTemplateId;
      if (currentSelectedTemplateIsWhatsapp) {
        bodyData.content = ""; // Text wird im Backend generiert
      }
    }

    fetch(`/api/cloud-messaging/conversations/${currentConversationId}/reply`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(bodyData),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Send failed");
        return response.json();
      })
      .then((msg) => {
        msgInput.value = "";
        currentSelectedTemplateId = null;
        currentSelectedTemplateIsWhatsapp = false;
        updateInputState();
        // Reload messages to handle grouping correctly
        fetch(`/api/cloud-messaging/conversations/${currentConversationId}`)
          .then((res) => res.json())
          .then((conv) => {
            if (conv) loadMessages(conv);
          });

        if (currentStatus !== "WARTET") {
          document.querySelector('#statusTabs .btn[data-status="WARTET"]').click();
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        btnSend.disabled = false;
      });
  };

  if (btnSend) {
    btnSend.addEventListener("click", sendMessage);
  }

  if (msgInput) {
    msgInput.addEventListener("keypress", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
      }
    });
  }

  // Complete Conversation
  const btnComplete = document.getElementById("btnCompleteConversation");
  if (btnComplete) {
    btnComplete.addEventListener("click", () => {
      if (!currentConversationId) return;

      fetch(
        `/api/cloud-messaging/conversations/${currentConversationId}/status?status=ABGESCHLOSSEN`,
        {
          method: "POST",
          headers: getHeaders(),
        },
      ).then((response) => {
        if (response.ok) {
          emptyChatPane.style.display = "flex";
          chatPane.style.display = "none";
          currentConversationId = null;
          document.querySelector(".messaging-container")?.classList.remove("mobile-chat-active");
          loadConversations();
        }
      });
    });
  }

  // Helpers
  const getInitials = (vorname, nachname) => {
    let initials = "";
    if (vorname && vorname.length > 0) initials += vorname[0].toUpperCase();
    if (nachname && nachname.length > 0) initials += nachname[0].toUpperCase();
    if (!initials) initials = "A";
    return initials;
  };

  const getAvatarHtml = (vorname, nachname, avatarUrl, size = "sm") => {
    const initials = getInitials(vorname, nachname);
    const char1 = initials.charAt(0) || "A";
    const name = `${vorname || ""} ${nachname || ""}`.trim();

    let extraClass = size === "sm" ? "me-3" : "";
    let sizeStyle = "";
    let fontSize = "";
    if (size === "sm") {
      sizeStyle = "width: 30px; height: 30px;";
      fontSize = "0.8rem";
    } else if (size === "md") {
      sizeStyle = "width: 40px; height: 40px;";
      fontSize = "1rem";
    }

    if (avatarUrl) {
      return `<div class="avatar-container ${extraClass}"><img src="${avatarUrl}" class="avatar rounded-circle" alt="${name}" style="${sizeStyle} object-fit: cover;"></div>`;
    } else {
      const colors = {
        A: "#FF5733",
        B: "#33FF57",
        C: "#3357FF",
        D: "#FF33A1",
        E: "#FF8C33",
        F: "#33FFF5",
        G: "#8C33FF",
        H: "#FF3333",
        I: "#33FF8C",
        J: "#5733FF",
        K: "#FF5733",
        L: "#33FF57",
        M: "#3357FF",
        N: "#FF33A1",
        O: "#FF8C33",
        P: "#33FFF5",
        Q: "#8C33FF",
        R: "#FF3333",
        S: "#33FF8C",
        T: "#5733FF",
        U: "#FF5733",
        V: "#33FF57",
        W: "#3357FF",
        X: "#FF33A1",
        Y: "#FF8C33",
        Z: "#33FFF5",
      };
      const color1 = colors[char1] || "#6c757d";
      const color2 = "#adb5bd";
      return `<div class="avatar-container flex-shrink-0 ${extraClass}"><div style="background: linear-gradient(135deg, ${color1} 0%, ${color2} 100%); color: white; text-shadow: 0px 1px 2px rgba(0,0,0,0.2); ${sizeStyle} font-size: ${fontSize};" class="avatar-initials rounded-circle d-flex align-items-center justify-content-center fw-bold">${initials}</div></div>`;
    }
  };

  const MEDIA_PLACEHOLDER_REGEX = /^\[(Bild|Video|Audio\/Sprachnachricht)\]$/;

  const getMediaHtml = (msg) => {
    if (!msg.mediaUrl) return "";
    const url = msg.mediaUrl.replace(/"/g, "&quot;");

    switch (msg.mediaType) {
      case "image":
        return `<a href="${url}" target="_blank" rel="noopener" class="media-preview mb-1"><img src="${url}" alt="Bild"></a>`;
      case "video":
        // #t=0.1 lässt den Browser ein Standbild als Vorschau zeigen statt einer schwarzen Fläche
        return `
          <div class="media-preview video-message mb-1">
            <video src="${url}#t=0.1" preload="metadata" playsinline></video>
            <button type="button" class="video-play" aria-label="Video abspielen"><i class="bi bi-play-fill"></i></button>
            <span class="video-duration"></span>
          </div>`;
      case "audio":
        return `
          <div class="voice-message mb-1">
            <button type="button" class="voice-play" aria-label="Sprachnachricht abspielen"><i class="bi bi-play-fill"></i></button>
            <div class="voice-body">
              <div class="voice-track"><div class="voice-bar"><div class="voice-progress"></div></div></div>
              <span class="voice-time">0:00</span>
            </div>
            <audio src="${url}" preload="metadata"></audio>
          </div>`;
      default:
        return `<a href="${url}" target="_blank" rel="noopener">Datei öffnen</a>`;
    }
  };

  // Sprachnachrichten-Player und Video-Vorschau im WhatsApp-Stil. Media-Events bubbeln nicht,
  // deshalb in der Capture-Phase am Container lauschen (überlebt das Neu-Rendern).
  const formatMediaTime = (seconds) => {
    if (!Number.isFinite(seconds)) return "0:00";
    const total = Math.floor(seconds);
    return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
  };

  const updateVoicePlayer = (audio) => {
    const player = audio.closest(".voice-message");
    if (!player) return;
    const hasDuration = Number.isFinite(audio.duration) && audio.duration > 0;
    const isActive = !audio.paused || audio.currentTime > 0;
    const ratio = hasDuration ? audio.currentTime / audio.duration : 0;

    player.querySelector(".voice-progress").style.width = `${Math.min(ratio, 1) * 100}%`;
    // Wie bei WhatsApp: beim Abspielen die abgelaufene Zeit, sonst die Gesamtdauer
    player.querySelector(".voice-time").textContent = isActive
      ? formatMediaTime(audio.currentTime)
      : formatMediaTime(audio.duration);
    player.querySelector(".voice-play i").className = audio.paused
      ? "bi bi-play-fill"
      : "bi bi-pause-fill";
  };

  const updateVideoPreview = (video) => {
    const preview = video.closest(".video-message");
    if (!preview) return;
    preview.querySelector(".video-duration").textContent = Number.isFinite(video.duration)
      ? formatMediaTime(video.duration)
      : "";
  };

  const resetVideoPreview = (video) => {
    const preview = video.closest(".video-message");
    if (!preview) return;
    preview.classList.remove("is-playing");
    video.controls = false;
    video.currentTime = 0.1;
  };

  // Immer nur ein Medium gleichzeitig abspielen
  const pauseOtherMedia = (current) => {
    messagesContainer.querySelectorAll("audio, video").forEach((other) => {
      if (other !== current) other.pause();
    });
  };

  if (messagesContainer) {
    ["loadedmetadata", "durationchange"].forEach((type) =>
      messagesContainer.addEventListener(
        type,
        (e) => {
          if (e.target.tagName === "VIDEO") updateVideoPreview(e.target);
        },
        true,
      ),
    );

    ["loadedmetadata", "durationchange", "timeupdate", "play", "pause"].forEach((type) =>
      messagesContainer.addEventListener(
        type,
        (e) => {
          if (e.target.tagName === "AUDIO") updateVoicePlayer(e.target);
        },
        true,
      ),
    );

    messagesContainer.addEventListener(
      "ended",
      (e) => {
        if (e.target.tagName === "VIDEO") {
          resetVideoPreview(e.target);
          return;
        }
        if (e.target.tagName !== "AUDIO") return;
        e.target.currentTime = 0;
        updateVoicePlayer(e.target);
      },
      true,
    );

    messagesContainer.addEventListener("click", (e) => {
      // Video: erst beim Klick Steuerelemente einblenden und abspielen
      const videoPreview = e.target.closest(".video-message");
      if (videoPreview && !videoPreview.classList.contains("is-playing")) {
        const video = videoPreview.querySelector("video");
        videoPreview.classList.add("is-playing");
        video.controls = true;
        pauseOtherMedia(video);
        video.play();
        return;
      }

      const player = e.target.closest(".voice-message");
      if (!player) return;
      const audio = player.querySelector("audio");

      if (e.target.closest(".voice-play")) {
        if (audio.paused) {
          pauseOtherMedia(audio);
          audio.play();
        } else {
          audio.pause();
        }
      } else if (e.target.closest(".voice-track") && Number.isFinite(audio.duration)) {
        const rect = player.querySelector(".voice-track").getBoundingClientRect();
        const ratio = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
        audio.currentTime = ratio * audio.duration;
      }
    });
  }

  const getChannelRef = (conv) => {
    const channel = conv.channel;
    const kontakt = conv.kontakt;
    if (!kontakt) return "Keine Info";
    switch (channel) {
      case "WHATSAPP_DIRECT":
      case "WHATSAPP_TEMPLATE":
      case "SMS":
        return kontakt.telefon || "Keine Telefonnummer";
      case "FACEBOOK":
        return kontakt.facebookId || "Facebook Kontakt";
      case "INSTAGRAM":
        return kontakt.instagramId || "Instagram Kontakt";
      case "EMAIL":
        return kontakt.email || "Keine E-Mail";
      default:
        return "Unbekannt";
    }
  };

  const getChannelIcon = (channel) => {
    switch (channel) {
      case "WHATSAPP_DIRECT":
      case "WHATSAPP_TEMPLATE":
        return '<i class="bi bi-whatsapp text-success" style="font-size: 1.2rem;"></i>';
      case "FACEBOOK":
        return '<i class="bi bi-facebook text-primary" style="font-size: 1.2rem;"></i>';
      case "INSTAGRAM":
        return '<i class="bi bi-instagram text-danger" style="font-size: 1.2rem;"></i>';
      case "EMAIL":
        return '<i class="bi bi-envelope text-secondary" style="font-size: 1.2rem;"></i>';
      case "SMS":
        return '<i class="bi bi-chat-text text-info" style="font-size: 1.2rem;"></i>';
      default:
        return `<i class="bi bi-chat text-secondary" style="font-size: 1.2rem;"></i>`;
    }
  };

  // Expose a method for WebSocket to append messages
  window.appendIncomingMessage = (canonicalMsg) => {
    if (currentConversationId) {
      fetch(`/api/cloud-messaging/conversations/${currentConversationId}`)
        .then((res) => res.json())
        .then((conv) => {
          if (conv) loadMessages(conv);
        });
    }
    loadConversations();
    updateUnreadCounts();
  };

  const btnBackToList = document.getElementById("btnBackToList");
  if (btnBackToList) {
    btnBackToList.addEventListener("click", () => {
      document.querySelector(".messaging-container")?.classList.remove("mobile-chat-active");
    });
  }

  // Initial Load
  loadConversations();
  updateUnreadCounts();
});

window.updateMessageStatus = function (statusUpdate) {
  const msgDiv = document.querySelector(`div[data-message-id="${statusUpdate.externalMessageId}"]`);
  if (msgDiv) {
    const tickContainer = msgDiv.querySelector(".tick-container");
    if (tickContainer) {
      let tickHtml = "";
      if (statusUpdate.status === "GESENDET") {
        tickHtml = `<i class="bi bi-check2 ms-1" style="font-size: 1rem; margin-bottom: -2px;"></i>`;
      } else if (statusUpdate.status === "EMPFANGEN") {
        tickHtml = `<i class="bi bi-check2-all ms-1" style="font-size: 1rem; margin-bottom: -2px;"></i>`;
      } else if (statusUpdate.status === "GELESEN") {
        tickHtml = `<i class="bi bi-check2-all ms-1" style="color: #0d6efd; font-size: 1rem; margin-bottom: -2px;"></i>`;
      } else if (statusUpdate.status === "FEHLER") {
        tickHtml = `<i class="bi bi-x-circle ms-1" style="color: #dc3545; font-size: 1rem; margin-bottom: -2px;"></i>`;
      } else {
        tickHtml = `<i class="bi bi-check2-all ms-1" style="font-size: 1rem; margin-bottom: -2px;"></i>`;
      }
      tickContainer.innerHTML = tickHtml;
    }
  }
};
